import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manufacturing_ds_locations_by_warehouseId_for_manufacturing_settingsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouse_id: number, name?: string }): 
  Promise<{ result: { Id?: number, IsManufacturingStagingLocation?: boolean, ManufacturingLineFlag?: boolean, Name?: string, ParentId?: number, Status?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouse_id)) {
      missingRequiredInParams.push('\'warehouse_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_locations_by_warehouseId_for_manufacturing_settings/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { warehouse_id: number, name?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, IsManufacturingStagingLocation?: boolean, ManufacturingLineFlag?: boolean, Name?: string, ParentId?: number, Status?: { Name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouse_id)) {
      missingRequiredInParams.push('\'warehouse_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_locations_by_warehouseId_for_manufacturing_settings/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouse_id: number, name?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, IsManufacturingStagingLocation?: boolean, ManufacturingLineFlag?: boolean, Name?: string, ParentId?: number, Status?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouse_id)) {
      missingRequiredInParams.push('\'warehouse_id\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_locations_by_warehouseId_for_manufacturing_settings/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      warehouse_id: number, name?: string    }) {
        if(isNil(inParams.warehouse_id)) {
          return true; 
        }
      return false;
    }
}
